module.exports = __webpack_public_path__ + "media/images/sp/specials/common/clean_side-da9e742a876ba2422e8eac502ac7d3f7.png";